'use client';

import { usePathname } from 'next/navigation';
import { OverviewBelowChartSkeleton, OverviewSidebarSkeleton } from '../../../../src/components/Quote/QuoteSkeletons';
import { EquityOverviewSkeleton } from './_components/EquityOverviewSkeleton';

export default function QuotePageLoading() {
  const isOverview = usePathname()?.split('/').filter(Boolean).length === 2;

  if (isOverview) {
    return <EquityOverviewSkeleton />;
  }

  return (
    <div className="main-div w-full flex gap-4 px-4">
      <div className="w-full flex flex-col gap-8 md:gap-4 p-0">
        <div className="top-area-and-sidebar-container w-full flex mx-auto max-w-[1400px] gap-4">
          <div className="w-full lg:w-8/12 flex flex-col gap-8 md:gap-4">
            <div
              className="card h-[400px] md:h-[500px] !p-0 bg-white overflow-hidden"
              aria-busy="true"
              aria-label="Loading quote"
            />
            <OverviewBelowChartSkeleton />
          </div>
          <div className="w-full lg:w-4/12">
            <OverviewSidebarSkeleton />
          </div>
        </div>
      </div>
    </div>
  );
}
